// extracted by mini-css-extract-plugin
export default {"app":"App_app__SjoeV","app-content":"App_app-content__K3beS","error-icon":"App_error-icon__D24PC"};